import React from 'react';
import { motion } from 'framer-motion';
import { PhoneIcon, ClockIcon } from 'lucide-react';
import { COMPANY } from '../../lib/site';
export function EmergencyCTA() {
  return <section className="relative overflow-hidden py-24" data-id="element-216" data-mp="yw7u0jtbzax1">
      <div className="mx-auto max-w-6xl px-6" data-id="element-217" data-mp="ywpuxtqxudba">
        <motion.div initial={{
        opacity: 0,
        y: 40,
        filter: 'blur(12px)'
      }} whileInView={{
        opacity: 1,
        y: 0,
        filter: 'blur(0px)'
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.9,
        ease: [0.22, 1, 0.36, 1]
      }} className="relative overflow-hidden rounded-[2.5rem] bg-white p-10 shadow-glow sm:p-14" data-id="element-218" data-mp="txdcrmb0huf1">
          {/* red emergency strip */}
          <div className="absolute inset-x-0 top-0 h-1.5 bg-gradient-to-r from-fire via-crimson to-fire" data-id="element-219" data-mp="693tar19tir2" />
          {/* soft blue wave background */}
          <svg className="absolute inset-0 h-full w-full opacity-[0.12]" viewBox="0 0 800 400" preserveAspectRatio="none" fill="none" data-id="element-220" data-mp="20qzf0vahn08">
            <motion.path d="M0,220 C200,150 400,300 800,200 L800,400 L0,400 Z" fill="#0057FF" animate={{
            d: ['M0,220 C200,150 400,300 800,200 L800,400 L0,400 Z', 'M0,240 C220,300 420,140 800,240 L800,400 L0,400 Z', 'M0,220 C200,150 400,300 800,200 L800,400 L0,400 Z']
          }} transition={{
            duration: 12,
            repeat: Infinity,
            ease: 'easeInOut'
          }} data-id="element-221" data-mp="3o7xtmd0ul24e" />
          </svg>

          <div className="relative flex flex-col items-center gap-8 text-center lg:flex-row lg:justify-between lg:text-left" data-id="element-222" data-mp="2wghx9r9ho10z">
            <div data-id="element-223" data-mp="30id0x2ew6qhx">
              <span className="inline-flex items-center gap-2 rounded-full bg-fire/10 px-4 py-1.5 text-xs font-bold uppercase tracking-widest text-fire" data-id="element-224" data-mp="30gtjv9lewbf3">
                <span className="relative flex h-2 w-2" data-id="element-225" data-mp="128xocpgmh4ec">
                  <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-fire opacity-75" data-id="element-226" data-mp="127ctszub5lgh" />
                  <span className="relative inline-flex h-2 w-2 rounded-full bg-fire" data-id="element-227" data-mp="x7hzembbqdqo" />
                </span>
                24/7 Emergency Line
              </span>
              <h2 className="mt-4 font-display text-3xl font-bold leading-tight text-navy sm:text-4xl md:text-5xl" data-id="element-228" data-mp="1pwxg9spo70ui">
                24/7 Emergency Restoration
              </h2>
              <p className="mt-3 flex items-center justify-center gap-2 text-slate lg:justify-start" data-id="element-229" data-mp="1fzav4ohs2d23">
                <ClockIcon className="h-4 w-4 text-royal" data-id="element-230" data-mp="1bz8vekvlrtpg" />
                Rapid response across {COMPANY.serviceArea}
              </p>
            </div>

            <motion.a href={COMPANY.phoneHref} data-cursor="button" whileHover={{
            scale: 1.04
          }} whileTap={{
            scale: 0.97
          }} className="relative flex shrink-0 items-center gap-4 rounded-full bg-fire px-8 py-5 text-white shadow-fire" data-id="element-231" data-mp="4ikmkypvt95b">
              <span className="absolute inset-0 rounded-full bg-fire animate-pulse-ring" data-id="element-232" data-mp="2l610jxyxqe16" />
              <PhoneIcon className="relative h-7 w-7" data-id="element-233" data-mp="2pzn14rrtqrgm" />
              <span className="relative" data-id="element-234" data-mp="2uxom5i8t90uq">
                <span className="block text-xs font-medium uppercase tracking-wider opacity-80" data-id="element-235" data-mp="2uwnbvfzmcie2">
                  Call Now
                </span>
                <span className="block font-display text-xl font-bold sm:text-2xl" data-id="element-236" data-mp="33y3a6pd5su1x">
                  {COMPANY.phoneDisplay}
                </span>
              </span>
            </motion.a>
          </div>
        </motion.div>
      </div>
    </section>;
}